module.exports = __webpack_public_path__ + "media/images/icon_mail01_18-14-b14a95a6f53097343fab6a8511c3c47f.png";